import { UrlActionTypes } from './url.types';

export const setUnpublishedURLs = urlData => ({
  type: UrlActionTypes.SET_UNPUBLISHED_URLS,
  payload: urlData
});

export const setFilteredURLs = urlData => ({
  type: UrlActionTypes.SET_FILTERED_URLS,
  payload: urlData
});

export const setURLStatusAsReviewed = data => ({
  type: UrlActionTypes.SET_URL_AS_REVIEWED,
  payload: data
});

export const setURLStatusAsIgnored = data => ({
  type: UrlActionTypes.SET_URL_AS_IGNORED,
  payload: data
});

export const setFilteredURLStatusAsReviewed = data => ({
  type: UrlActionTypes.SET_FILTERED_URL_AS_REVIEWED,
  payload: data
});

export const setFilteredURLStatusAsIgnored = data => ({
  type: UrlActionTypes.SET_FILTERED_URL_AS_IGNORED,
  payload: data
});

export const removeIgnoredUrls = urls => ({
  type: UrlActionTypes.REMOVE_IGNORED_URLS,
  payload: urls
});

export const setPublishNotificationSummary = data => ({
  type: UrlActionTypes.SET_PUBLISH_NOTIFICATION_SUMMARY,
  payload: data
});

export const setPublishSummary = data => ({
  type: UrlActionTypes.SET_PUBLISH_SUMMARY,
  payload: data
});

export const setRevisedCategory = data => ({
  type: UrlActionTypes.SET_REVISED_CATEGORY,
  payload: data
});

export const setRevisedCatForFilteredURls = data => ({
  type: UrlActionTypes.SET_FILTERED_URL_REVISED_CAT,
  payload: data
});